{
  "Para1": "Sélectionnez une disposition de tableau de bord parmi les options ci-dessous :",
  "DashboardDisplaySettings_SectionHeader": "Paramètres d'affichage",
  "NAME": "DashboardDisplaySettings"
}